import { useCallback, useMemo } from 'react';
import _ from 'lodash';

/**
 * @description Receives an Array with all children and return an object with
 * each node containing a array with all its children
 *
 * @param {array} treeTestNodes
 * @returns  {object} { id: '', label: '', parentId: '', projectId: '', order: 1,  child: [] }
 */
const TreeRemap = (treeTestNodes) => {
  const treeList = useMemo(() => (
    _.chain(treeTestNodes)
      .map((treeValue) => ({ ...treeValue, child: [] }))
      .filter((treeValue) => !_.get(treeValue, '_destroy')) // Used to not show child that was removed
      .value() || []
  ),
  [treeTestNodes]);

  const childrenGrouped = useMemo(() => _.groupBy(treeList, 'parentId'), [treeList]);
  const firstRoot = useMemo(() => _.head(_.get(childrenGrouped, 'null', {})), [childrenGrouped]);

  // Used to create the tree with your children
  const createBranch = useCallback((root, posChild) => {
    if (posChild > treeList.length || _.isEmpty(root)) return {};

    const rootTree = root;

    if (childrenGrouped[rootTree.id]) {
      rootTree.child = _.chain(childrenGrouped[rootTree.id])
        .map((node) => node)
        .sortBy('order')
        .value();
    }

    for (let i = 0; i < root.child.length; i += 1) {
      createBranch(root.child[i], posChild + 1);
    }

    return rootTree;
  }, [childrenGrouped, treeList.length]);

  // If the array has one element, that means that the element is the root
  if (!_.isEmpty(treeList) && treeList.length === 1 && !_.isEmpty(firstRoot)) {
    return firstRoot;
  }

  // Build the tree to be used by the component
  const rootTree = createBranch(firstRoot, 0);

  return rootTree;
};

export default TreeRemap;
